import { Brand, MobileVariant, StepperVariant } from "../types";
import React from "react";
import { StepItem } from "../StepItem";
import { StepList } from "./styled";
export const MobileStepper = ({ stepCompleteIcon, disableUpcomingSteps, currentStep, children, steps, handleNavigate, mobileVariant = MobileVariant.HORIZONTAL_LINE, branding = Brand.DEFAULT, }) => {
    return (React.createElement(StepList, null, steps.map((step, index) => {
        const liElement = (childElements) => (React.createElement("li", { key: step.id },
            React.createElement(StepItem, { step: step, currentStep: currentStep, stepCompleteIcon: stepCompleteIcon, stepperVariant: StepperVariant.MOBILE, disableUpcomingSteps: disableUpcomingSteps, handleNavigate: handleNavigate, stepNumber: index + 1, lastStep: index === steps.length - 1, mobileVariant: mobileVariant, isMobileLayout: true, branding: branding }, childElements)));
        if (step.id === currentStep.id) {
            return liElement(children);
        }
        return liElement();
    })));
};
//# sourceMappingURL=index.js.map